import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithData } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }

    const sessionId = match[1];
    // Clear the hash immediately
    window.history.replaceState(null, "", window.location.pathname);

    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/google/callback`, {
          session_id: sessionId,
        });
        // Set auth state via context
        loginWithData(data);
        // iter1097 — Google OAuth users прескачат Register form-a. Ако още
        // не са минали Health Assessment → пращаме ги в /onboarding
        // (там Cycle Modal ще се auto-open за жени без LMP, после Assessment,
        // после Step 4 „Готов" → Dashboard).
        const completed = !!data?.profile?.completedOnboarding;
        navigate(completed ? "/dashboard" : "/onboarding", { replace: true });
      } catch (e) {
        // google auth callback error silently handled
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, loginWithData]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center space-y-4">
        <div className="w-10 h-10 border-4 border-[#0EA5E9] border-t-transparent rounded-full animate-spin"></div>
        <p className="text-muted-foreground text-sm">Authenticating with Google...</p>
      </div>
    </div>
  );
}
